export default __webpack_public_path__ + "static/Atlanta-34a618b8e73ffc1fc158d77d8cd0c265.webp";